export const STORAGE_KEYS = {
  TOKEN: "token",
  ROLE: "role",
  AUTH_STATE: "googleOAuthState",
  ACTIVE_DASHBOARD_TAB: "activeTab",
  LOW_STOCKMESSAGE: "lowStockToasts"
};
